<template>
    <div class="page">
        <div class="content">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    :immediate-check="false"
                    @load="bindList"
                    class="content-collect"
            >
                <div class="content-li" v-for="(item,index) in list" :key="index" :data-link="item.link" @click="bindMore">
                    <div class="content-img">
                        <div :style="'background:url('+item.course_cover_url+'?x-oss-process=style/w240-h135) center center no-repeat;background-size:cover;height:100%'"></div>
                        <!--<image src="{{item.cover}}" mode="widthFix" style="width:100%;height:100%"></image>-->

                        <div class="content-info-view">
                            <span class="iconfont iconchakan"></span>
                            {{item.play_times}}
                        </div>
                        <div class="content-info-type">
                            {{item.mates_type_cn}}
                        </div>

                    </div>
                    <div class="content-title">
                        {{item.section_name}}
                    </div>
                    <div class="content-info">
                        <div class="content-info-play-time">
                            {{item.lecturer}}
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
    import { List } from 'vant';
    export default {
        name: "index",
        components:{
            [List.name]:List
        },
        data(){
            return {
                list:[],
                total:0,
                is_show:false,
                page:1,
                pageSize:14,
                loading: false,
                finished: false,
            }
        },
        mounted(){
            this.util.hideOptionMenu();
            this.bindList(1);
        },
        methods:{
            bindMore:function (e) {
                this.$router.push(this.util.urlPrefix+e.currentTarget.dataset.link);

                // this.util.carouselUrl(e.currentTarget.dataset.link);
            },
            bindList:function(page){
                var _self=this;
                if(!page){
                    var pageNo = this.page;
                    pageNo +=1;

                    this.page=pageNo;

                }else{

                    this.page=page;

                }
                this.util.server.mini_v1_my.play_list({
                    data:{
                        page:this.page,
                        pagesize:this.pageSize
                    },
                    methods:'get',
                    callback: (res => {
                        const { code, data, msg } = res;

                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.total=data.total
                            }
                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                for (var i = 0; i < data.items.length; i++) {
                                    data.items[i]['link'] = this.util.getMiniCourseTypeUrl(data.items[i].type, data.items[i].course_id, data.items[i].p_course_id) + '&current=' + data.items[i].sections_id;
                                }
                                if(page == 1){
                                    this.list=data.items;
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.list = this.list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.loading = false;
                                //判断是否存在下一页
                                if(this.total*1 == this.list.length){
                                    this.finished=true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.list=[];
                                    this.finished=true;
                                    this.loading = false;
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            }
        }
    }
</script>

<style scoped>
    div{
        color: #3a3a3a;
    }
    .page{
        padding: 10px;
        box-sizing: border-box;
    }
    .content{
        background-color: #fff;
    }
    .content-collect{
        width: 100%;
    }
    .content-collect .content-li{
        padding: 10px;
        box-sizing: border-box;
        position: relative;
        width: 50%;
        display: inline-block;
    }
    .content-li .content-img{
        position: relative;
        height: 100px;
        font-size: 0;
    }
    .content-info{
        min-height: 16px;
    }
    .content-img .content-info-view{
        position: absolute;
        font-size: 10px;
        color: #ffffff;
        top: 0;
        margin: 3px;
        padding: 2px 6px;
        background: rgba(0,0,0,0.4);
        border-radius: 8px;
    }
    .content-info-view .iconfont{
        font-size: 10px;
    }
    .content-li .content-title{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        height: 38px;
    }
    .content-li .content-info-play-time{
        font-size: 12px;
        margin-right: 15px;
    }
    .content-no-collect{
        position: absolute;
        bottom: 0;
        right: 0;
        margin-bottom: 10px;
        margin-right: 10px;
    }
    .content-no-collect .iconfont{
        color: #f30;
    }
    .no-list{
        text-align: center;
        width: 100%;
    }
    .content-info-type{
        position: absolute;
        top: 0;
        right: 0;
        margin: 3px;
        padding: 2px 6px;
        font-size: 10px;
        color: #ffffff;
        background: rgba(0,0,0,0.4);
        border-radius: 5px;
    }
</style>
